var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreeMapChartBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3002 15.8496H1V28.0002H14.3002V15.8496Z",
    fill: "#185EDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9986 1H19.8984V3.70012H28.9986V1Z",
    fill: "#B7BDEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9986 4.37305H19.8984V10.4483H28.9986V4.37305Z",
    fill: "#185EDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0008 23.9492H24.8008V27.9994H29.0008V23.9492Z",
    fill: "#B7BDEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0993 23.9492H15.6992V27.9994H24.0993V23.9492Z",
    fill: "#185EDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4752 1H1V8.08783H14.4752V1Z",
    fill: "#185EDF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H1V15H14V9Z",
    fill: "#B7BDEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1993 1H15.6992V10.4504H19.1993V1Z",
    fill: "#B7BDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9994 11.8008H15.6992V23.2763H28.9994V11.8008Z",
    fill: "#B7BDEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeMapChartBlue);
export default __webpack_public_path__ + "static/media/tree-map-chart-blue.e005bc0ea332af27a89aa8ecb52b31fe.svg";
export { ForwardRef as ReactComponent };